import { put, takeLatest } from "@redux-saga/core/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { call } from "redux-saga/effects";
import fetchAPI, { ApiResponse, HttpMethod } from "../../../utils/api";
import { showError, showSuccess } from "../../toaster/store/slice";
import { RegisterFormValues } from "../RegisterPage";
import registerPageSlice from "./slice";

type RegisterResponse = ApiResponse<{ success: boolean }>;
type RegisterRequest = {
  contact_name: string;
  contact_email: string;
  contact_phone: string;
  company_name: string;
  company_registration_code: string;
  company_vat_code: string;
  company_address: string;
  prefered_directions: string;
  recaptcha_token: string;
};

function* registerPageSaga() {
  yield takeLatest(registerPageSlice.actions.sendRequest, handleSend);
}

function* handleSend({ payload }: PayloadAction<RegisterFormValues>) {
  const body: RegisterRequest = {
    contact_name: payload.contactName,
    contact_email: payload.contactEmail,
    contact_phone: payload.contactPhone,
    company_name: payload.companyName,
    company_registration_code: payload.companyRegistrationCode,
    company_vat_code: payload.companyVatCode,
    company_address: payload.companyAddress,
    prefered_directions: payload.preferedDirections,
    recaptcha_token: payload.recaptchaToken,
  };

  const response: RegisterResponse = yield call(fetchAPI, "/register", {
    method: HttpMethod.POST,
    body: JSON.stringify(body),
  });

  if (response && response.success) {
    yield put(registerPageSlice.actions.setRequestSend());

    yield put(
      showSuccess(
        "Thank you. Your form has been submitted. We will contact you within 2 working days."
      )
    );
  } else {
    yield put(
      showError("Something went wrong. Please try again or contact support.")
    );
  }

  yield put(registerPageSlice.actions.setIsLoading(false));
}

export default registerPageSaga;
